const { ReadSectionEnum, FEATURED_SECTION } = require('../constants/read');

/**
 * This function is used to normalize flatten prismic response into different read section and subsection.
 * For example:
 * @Prismic Response:
 * [{data: {..., readCategory: [ {featuredCategory: "episodes"} {featuredCategory: "season-1"}]}}]
 *
 * Since readCategory doesn't differentiate between section & subsection, we need to filter subSection by finding section first.
 *
 * @returns
 * {
 *  season-1: {[subSection1]: [data1, data2], [subSection2]: [data1, data2] }
 *  season-2: {[subSection1]: [data1, data2]}
 *  season-3: {[subSection1]: [data1, data2
 *  women-in-christian-history: [data1, data2] //  women-in-christian-history doesnot have sub category
 *  blog: [data1, data2] //Note: Blog doesn't have sub-section
 *
 * }
 *
 *
 **/
const normalizeReadCategories = (readCategories, isDataDetailsRequired = true) => {
  return readCategories.reduce((acc, value) => {
    const categories = value?.data?.readCategories?.map((elem) => elem?.readCategory?.featuredCategory);
    const section = !!categories ? categories?.find((elm) => Object.values(ReadSectionEnum).includes(elm)) : [];
    const { url, id } = value;
    let details = isDataDetailsRequired ? { ...value?.data, id, url } : { id, url };
    const subSection = categories?.filter((elm) => elm !== section && elm !== FEATURED_SECTION);

    // Seasons have subsections; Blog and Women do not.
    if (!!subSection?.length) {
      subSection.map((subSection) => {
        details = { ...details };
        acc = {
          ...acc,
          [section]: !!acc[section]
            ? {
              ...acc[section],
              [subSection]: !!acc[section][subSection] ? [...acc[section][subSection], details] : [details],
            }
            : { [subSection]: [details] },
        };
      });
    } else {
      // Items with no subsections:
      // - For seasonal sections (season-1/2/3), default to BLOG to avoid mixing shapes
      // - For BLOG and WOMEN_IN_CHRISTIAN_HISTROY, collect under their own section
      details = { ...details };
      const isSeason =
        section === ReadSectionEnum.SEASON_1 ||
        section === ReadSectionEnum.SEASON_2 ||
        section === ReadSectionEnum.SEASON_3;
      const isWomen = section === ReadSectionEnum.WOMEN_IN_CHRISTIAN_HISTROY;
      const targetSection = isSeason
        ? ReadSectionEnum.BLOG
        : isWomen
          ? ReadSectionEnum.WOMEN_IN_CHRISTIAN_HISTROY
          : ReadSectionEnum.BLOG;

      acc = {
        ...acc,
        [targetSection]: Array.isArray(acc[targetSection]) ? [...acc[targetSection], details] : [details],
      };
    }

    return acc;
  }, {});
};

module.exports = {
  normalizeReadCategories,
};
